import React, { createContext, useContext, useEffect, useState } from "react";
import jwtDecode from "jwt-decode"; 
import SparkApi from "../../api/SparkApi"; 

const PermissionContext = createContext();

export const PermissionProvider = ({ children }) => {
  const [permissionData, setPermissionData] = useState({});
  const [userInfo, setUserInfo] = useState(null);

  const fetchPermission = async (uid) => {
    try {
      const permissionSet = await SparkApi.fetchRolePermissions(uid);
      
      if (permissionSet.success) {
        const permissions = permissionSet?.result?.reduce((acc, module) => {
          const moduleName = module?.name?.trim().replace(/\s+/g, '_');
          acc[moduleName] = {
            can_read: module.can_read,
            can_create: module.can_create,
            can_edit: module.can_edit,
            can_delete: module.can_delete,
          };
          return acc;
        }, {});
        setPermissionData(permissions);
      } else {
        setPermissionData({});
      }
    } catch (error) {
      console.error("Error fetching permissions:", error);
      setPermissionData({});
    }
  };

  useEffect(() => {
    const token = sessionStorage?.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const uid = decoded.id;
        fetchPermission(uid);
        setUserInfo(decoded);
      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, []);

  return (
    <PermissionContext.Provider value={{ permissionData , userInfo , setUserInfo}}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermission = () => useContext(PermissionContext)